export default __webpack_public_path__ + "static/media/pk.374c54b0.png";